// Externe Bibliotheken
import React, { Component } from 'react';
import axios from 'axios';

// Interne Module
import * as storage from '@/_helper/storage';
import { convertPrice } from '@/_helper/mapper';

// Komponenten
import LoadingOffersBar from '@/comp/loadingOffersBar';
import { BackButton } from '@/comp/backButton/backButton';

const params = {
    errorWording: {
        insuranceOffer: 'Bitte wählen Sie eine Option aus.',
        accept: 'Bitte bestätigen Sie, dass Sie das Produktinformationsblatt und die Versicherungsbedingungen gelesen und zur Kenntnis genommen haben!',
    },
};

class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: 0,
            data: [],
            accept: false,
            isLoading: false,
            hasResult: false,
            insuranceOfferValid: false,
            acceptValid: false,
            formErrors: {
                insuranceOffer: '',
                accept: '',
            },
            error: null,
            formValid: false,
            formVacancy: false,
        };

        this.handleCheckClicked = this.handleCheckClicked.bind(this);

        this.handleUserInput = this.handleUserInput.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleUserInput(event) {
        const target = event.target;
        let value = target.value;
        const name = target.name;

        // if ( target.checked ) {
        value = target.checked !== true ? false : true;
        // }

        this.setState({ [name]: target.value }, () => {
            this.validateField(name, value);
        });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let acceptValid = this.state.acceptValid;
        let insuranceOfferValid = this.state.insuranceOfferValid;

        switch (fieldName) {
            case 'accept':
                acceptValid = value === true;
                fieldValidationErrors.accept = acceptValid ? '' : params.errorWording.accept;
                break;
            case 'insuranceOffer':
                insuranceOfferValid = value === true;
                fieldValidationErrors.insuranceOffer = insuranceOfferValid ? '' : params.errorWording.insuranceOffer;
                break;
            default:
                break;
        }
        this.setState(
            { formErrors: fieldValidationErrors, acceptValid: acceptValid, insuranceOfferValid: insuranceOfferValid },
            this.validateForm
        );
    }

    validateForm() {
        this.setState({ formValid: this.state.acceptValid && this.state.insuranceOfferValid });
    }

    handleCheckClicked(e) {
        this.setState({
            [e.target.name]: e.target.checked,
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        // form validation
        if (!this.state.formValid) {
            // form is invalid! so we do nothing

            // set error dialogs
            let fieldValidationErrors = this.state.formErrors;
            fieldValidationErrors.accept = params.errorWording.accept;
            fieldValidationErrors.insuranceOffer = params.errorWording.insuranceOffer;

            this.setState({
                formErrors: fieldValidationErrors,
            });

            return;
        }
        // form is valid!

        // Vacancy
        const sendVacancyData = {
            travelType: 'insurance',
            vacancyType: 'insurance',
            responseDetailLevel: 'full',
            ignoreCache: true,
            vacancyBeforeBooking: true,
            requestType: 'vacancy',
            clientId: 'customerarea',
            insuranceOfferKey: this.state.insuranceOffer,
            processToken: this.state.data.processToken,
        };

        this.setState({
            formVacancy: true,
        });

        let offerId = this.state.insuranceOffer;

        axios({
            url: window.$requestUrl + '/vacancy?token=' + window.$token,
            method: 'POST',
            data: JSON.stringify(sendVacancyData),
        })
            .then((response) => response)
            .then(function (response) {
                let bookStates = {
                    travelType: 'insurance',
                    vacancyToken: response.data.data.requestToken,
                    processToken: response.data.data.processToken,
                    offerId: offerId,
                    vacancyData: response.data.data.insuranceOffer,
                };

                sessionStorage.setItem('bookStates', JSON.stringify(bookStates));

                window.location.href = `#/buchung/${window.$content.extras['insurance'].link}`;
            })
            .catch((error) => this.setState({ error, formVacancy: false }));
    }

    componentDidMount() {
        const convertDate = function (date) {
            let tmp = date.split('.');
            return tmp[2] + '-' + tmp[1] + '-' + tmp[0];
        };

        const createPaxAges = function (pax) {
            let tmp = pax.split(';');
            let result = [];
            for (var i = 0; i < tmp.length; i++) {
                let tmp2 = tmp[i];
                let tmp3 = tmp2.split(':');
                result.push({ pax: tmp3[0], age: tmp3[1] });
            }
            return result;
        };

        let offers = storage.get('insuranceOffers');

        // remove old offers
        if (offers !== null && offers.data !== undefined && offers.data.travelType !== 'insurance') {
            storage.remove('insuranceOffers');
        } else if (offers !== null) {
            this.setState({
                data: offers.data,
                isLoading: false,
            });

            return false;
        }

        // loading state
        this.setState({ isLoading: true });

        // get requestData and send it
        let bookingData = storage.get('bookingData');
        let searchParams = undefined;
        if (bookingData !== null) {
            searchParams = bookingData.data.searchParams;
        }
        if (searchParams !== undefined) {
            const sendData = {
                requestType: 'searchExtra',
                travelType: 'insurance',
                regionCode: searchParams.destination,
                arrivalAirportCode: searchParams.retAirport,
                travelStart: convertDate(searchParams.depDate),
                travelEnd: convertDate(searchParams.retDate),
                paxAges: createPaxAges(searchParams.paxAges),
                filterTags: [],
                amountToBeInsured: parseFloat(searchParams.insuranceAmount),
                clientId: 'customerarea',
            };

            axios({
                url: window.$requestUrl + '/searchExtra?token=' + window.$token,
                method: 'POST',
                data: JSON.stringify(sendData),
            })
                .then((response) => response)
                .then((data) => {
                    this.setState({
                        data: data.data.data,
                        hasResult: true,
                    });

                    storage.set('insuranceOffers', {
                        data: data.data.data,
                    });
                })
                .catch((error) => this.setState({ error, isLoading: false }));
        }
    }

    render() {
        const { isLoading, error, hasResult } = this.state;

        if (error || this.state.data === undefined) {
            return (
                <div>
                    <div className="error">{window.$content.errorText}</div>
                    <div className="user-action">
                        <BackButton class="col" target="blank" />
                    </div>
                </div>
            );
        }

        if (isLoading) {
            if (hasResult) {
                setTimeout(() => {
                    this.setState({
                        isLoading: false,
                    });
                }, 2000);
            }
            return <LoadingOffersBar hasResult={hasResult} />;
        }

        // generate tabs
        const entries = [];

        if (this.state.data && this.state.data.insuranceOffers !== undefined) {
            const $insuranceOffers = this.state.data.insuranceOffers;

            if ($insuranceOffers.length === 0) {
                return (
                    <div>
                        <div className="error offers">{window.$content.errorNoOffersText}</div>
                        <div className="user-action">
                            <BackButton class="col" target="blank" />
                        </div>
                    </div>
                );
            }

            Object.keys($insuranceOffers).forEach((k) => {
                const {
                    conditionAgreement,
                    conditionLinkUrl,
                    conditionLinkLabel,
                    offers,
                    $offers = [],
                } = $insuranceOffers[k];

                const offer = Object.entries(offers);

                offer.forEach((item, key) => {
                    const { offerKey, price, serviceDescription } = offer[key][1];

                    $offers.push(
                        <div key={offer[key]} ref={offerKey} className="case">
                            <input
                                id={offer[key][0]}
                                type="radio"
                                name={'insuranceOffer'}
                                value={offer[key][0]}
                                onChange={(event) => this.handleUserInput(event)}
                            />
                            <div className="icon"></div>
                            <label htmlFor={offer[key][0]}>
                                <div className="inline-content">
                                    <div className="cnt">
                                        <h3 className="title">{serviceDescription}</h3>
                                    </div>

                                    <div className="price-sec">
                                        <small>Gesamtpreis</small>
                                        <div className="overall-price">
                                            {price.overallGrossPrice >= 0 ? '+' : '-'}{' '}
                                            {convertPrice(price.overallGrossPrice, 0, 0)}
                                        </div>
                                    </div>
                                </div>
                            </label>
                        </div>
                    );
                });

                entries.push(
                    <div key={k} className="entry">
                        <div className="offers">
                            {$offers}

                            {this.state.insuranceOfferValid === false &&
                                this.state.formErrors.insuranceOffer.length > 0 && (
                                    <div className="error">{this.state.formErrors.insuranceOffer}</div>
                                )}
                        </div>

                        <div className="accept-sec">
                            <input
                                id="accept"
                                name="accept"
                                type="checkbox"
                                onChange={(event) => this.handleUserInput(event)}
                            />
                            <label htmlFor="accept">
                                <div>{conditionAgreement}</div>
                                <div>
                                    <a href={conditionLinkUrl} target="_blank" rel="noopener noreferrer">
                                        {conditionLinkLabel}
                                    </a>
                                </div>
                            </label>
                        </div>

                        {this.state.acceptValid === false && this.state.formErrors.accept.length > 0 && (
                            <div className="error">{this.state.formErrors.accept}</div>
                        )}

                        <div className="user-action">
                            <BackButton class="col" target="blank" />

                            <button
                                className={
                                    'col ' +
                                    (this.state.formValid ? 'valid ' : 'invalid ') +
                                    (this.state.formVacancy ? 'validate' : '')
                                }
                                type="submit"
                                // disabled={!this.state.formValid}
                            >
                                {this.state.formVacancy ? (
                                    <span>Daten werden übermittelt ...</span>
                                ) : (
                                    <span>Weiter zur Übersicht</span>
                                )}

                                <i className="material-icons">arrow_forward</i>

                                <span className="loader"></span>
                            </button>
                        </div>
                    </div>
                );
            });
        }

        return (
            <form
                className={'txtL ' + (this.state.formVacancy ? 'validate' : '')}
                autoComplete="off"
                onSubmit={this.handleSubmit}
                method="post"
                noValidate="">
                {entries}
            </form>
        );
    }
}

export default Form;
